// extracted by mini-css-extract-plugin
module.exports = {"passMessage":"index_passMessage__12Ea-","lateral":"index_lateral__2FCR2","wrapperPassRecover":"index_wrapperPassRecover__1PR4f","inputPassRecover":"index_inputPassRecover__3UOoO"};